import { Box, Typography } from "@mui/material";
import { palette } from "../../../../styles/theme";

interface ProjectDragPreviewProps {
  projectName: string;
}

export const ProjectNavItemDragPreview = ({
  projectName,
}: ProjectDragPreviewProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        backgroundColor: palette.white,
        border: `1px solid ${palette.blue.secondary}`,
        borderRadius: "8px",
        boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.3)",
        padding: "12px 16px",
        minWidth: "200px",
        maxWidth: "250px",
        cursor: "grabbing",
        opacity: 0.5,
        pointerEvents: "none",
      }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          color: palette.grey.nearBlack,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          marginBottom: "2px",
        }}
      >
        {projectName}
      </Typography>
    </Box>
  );
};
